// https://theme-ui.com/theme-spec

/* Misc Notes:
  1. heading refers to h1, h2, h3, etc. Not the header/footer
  10. This file is executed once Serverside, and once Clientside
*/

/////    Brand Specific Color Settings    /////

const mandoPrimaryPalette = {

  primaries: {
    white: '#fff',
    black: '#000',
    blue: '#275681',
    navy: '#10253B',
    orange: '#FE5000',
  },

  // old
  backgrounds: {
    white: '#fff',
    black: '#000',
    
    
  },
  secondaries: {
    //    
  },

  scents: {
    bourbonLeather: '#7E2728',
    mtFuji: '#5B6670',
    proSport: '#275681',
    mandoOrange: '#FE5000',
    cloverWoods: '#1c4122',
    cedar: '#623d20',
  },

  // old -- Leave it in case people are referencing but don't have it as an option. 
  // Updated color codes to be similar color but in the new shade
  old: {
    shark: '#292c2e',
    offwhite: '#FAF7EF',
    international_orange: '#FE5000',
    crownofthorns: '#7E2728',
    bayofmany: '#10253B',
    shuttlegray: '#5B6670',
    everglade: '#1c4122',
    domino: '#8B7C5E',
    grellow: '#E2E735',
    yellow: '#FFE800',
    darkGreen: '#1c4122',
    blue: '#275681',
    red: '#FE5000',
    lightBlue: '#D5E0EE',
    grey: '#D0D0D0',
    darkGrey: '#4d5254',

  },

  fonts: {
    roboto: 'Roboto, Helvetica, Arial, sans-serif',
    robotoFlex: 'RobotoFlex, Helvetica, Arial, sans-serif',
    robotoSlab: 'RobotoSlab, Helvetica, Arial, sans-serif',
    robotoMedium: 'RobotoMedium, Helvetica, Arial, sans-serif',
    menlo: 'Menlo, monospace',
  },
  referenceColors: {
    text: '#0c0c0d', 
    body: '#0c0c0d', 
    heading: '#0c0c0d',
    background: '#0d0d0d', 
    primary: '#2B1453',
    secondary: '#9383CF', 
    muted: '#bfbfbf', 
    navList: '#ffffff', 
    headerCTA: '#D0D0D0', 
    link: '#3ca6e0', 
  }
};

// Theme config exported for access in components, build loop, and builder configs
const mandoStyles = {
  referenceColors: mandoPrimaryPalette.referenceColors,
  breakpoints: ['48em', '64em', '90em'],
  space: {
    none: '0',
    small: ['0.375em', '0.375em', '0.75em'], // Arrays set responsive values from smallest breakpoint to largest
    medium: ['0.5em', '0.5em', '1em'],
    large: ['0.75em', '0.75em', '1.5em'],
    xlarge: ['1.2em', '1.5em', '3em'],
    mega: ['4em', '4em', '8em'],
  },
  sizes: {
    container: ['100%', '43.25em', '61.25em', '76.25em'],
    viewHeight100: '100vh',
    viewWidth100: '100vw',
    navHeight: '75px',
    footerHeight: '250px',
  },
  fonts: {
    body: mandoPrimaryPalette.fonts.roboto,
    heading: mandoPrimaryPalette.fonts.blenderBold,
    monospace: mandoPrimaryPalette.fonts.menlo,
    nav: mandoPrimaryPalette.fonts.roboto,
  },
  fontSizes: [16, 18, 24, 19, 30, 24, 36, 36, 48, 32, 48],
  fontWeights: {
    body: 300,
    heading: 500,
    bold: 700,
  },
  lineHeights: {
    body: 1.75,
    heading: 1.25,
    button: 1.5,
  },
  letterSpacings: {
    body: 0.5,
    heading: 0.9,
    caps: '0.125em',
    caption: '0.0625em',
  },
  // User exposed color options in the Builder UI are also drawn from this theme
  // Color must be defined here to be used in backgroundColors and other sub categories
  colors: { 
    text: mandoPrimaryPalette.referenceColors.text,
    body: mandoPrimaryPalette.referenceColors.body,
    heading: mandoPrimaryPalette.referenceColors.heading,
    primary: mandoPrimaryPalette.primaries.black,
    secondary: mandoPrimaryPalette.secondaries.darkGrey,
    muted: mandoPrimaryPalette.old.darkGrey,
    link: mandoPrimaryPalette.old.darkGrey,

    orange: mandoPrimaryPalette.primaries.orange,
    
    white: mandoPrimaryPalette.primaries.white,
    black: mandoPrimaryPalette.primaries.black,
    offwhite: mandoPrimaryPalette.old.offwhite,
    blue: mandoPrimaryPalette.primaries.blue,
    navy: mandoPrimaryPalette.primaries.navy,
    
    transparent: 'transparent',


    // Old Backgrounds -- DELETE once it's no longer being used
    yellow: mandoPrimaryPalette.old.yellow,
    grellow: mandoPrimaryPalette.old.grellow,
    darkGreen: mandoPrimaryPalette.old.darkGreen,
    
    lightBlue: mandoPrimaryPalette.old.lightBlue,
    international_orange: mandoPrimaryPalette.old.international_orange,
    red: mandoPrimaryPalette.old.red,
    shark: mandoPrimaryPalette.old.shark,
    crownofthorns: mandoPrimaryPalette.old.crownofthorns,
    bayofmany: mandoPrimaryPalette.old.bayofmany,
    shuttlegray: mandoPrimaryPalette.old.shuttlegray,
    everglade: mandoPrimaryPalette.old.everglade,
    domino: mandoPrimaryPalette.old.domino,

  },
  // Used for component background colors
  backgroundColors: {
    orange: mandoPrimaryPalette.primaries.orange,
    orangeGradient: 'linear-gradient(135deg, #E04800 0%, #FE5000 50%, #FF6B35 100%)',
    white: mandoPrimaryPalette.primaries.white,
    black: mandoPrimaryPalette.primaries.black,
    blue: mandoPrimaryPalette.primaries.blue,
    navy: mandoPrimaryPalette.primaries.navy,
    transparent: 'transparent',

    // Deprecated: Need to keep here for existing references, but not in Builder.io enum
    lightBlue: mandoPrimaryPalette.backgrounds.lightBlue,
  },
  radii: {
    card: ['0.25em', '0.5em'],
    button: '0',
  },
  shadows: {
    card: '0 0.125em 0.1875em 0 rgba(0,0,0,0.2)',
  },
  text: {
    body: {
      fontFamily: 'body',
      fontWeight: 'body',
      lineHeight: 'body',
      letterSpacing: 'body',
    },
    heading: {
      fontFamily: 'heading',
      fontWeight: 'heading',
      lineHeight: 'heading',
      letterSpacing: 'heading',
    },
  },
  // theme variants
  buttons: {
    primary: {
      appearance: 'none',
      alignItems: 'center',
      bg: '#275681',
      border: 0,
      borderRadius: '50px',
      color: '#fff',
      display: 'inline-flex',
      fontFamily: mandoPrimaryPalette.fonts.robotoMedium,
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '700',
      justifyContent: 'center',
      lineHeight: 'button',
      letterSpacing: '.1rem',
      marginBottom: 'medium',
      padding: ['0.75em 1.5em', '0.75em 2em'],
      position: 'relative',
      verticalAlign: 'middle',
      whiteSpace: 'nowrap',
      transition: 'background-color 0.3s ease',
      cursor: 'pointer',
      
      '&:after': {
        content: '""',
        display: 'inline-block',
        width: '0',
        height: '0',
        marginLeft: '0.5em',
        borderTop: '0.3em solid transparent',
        borderBottom: '0.3em solid transparent',
        borderLeft: '0.4em solid currentColor',
        verticalAlign: 'middle',
        transition: 'transform 0.3s ease',
      },
      
      '&:hover': {
        bg: '#1e3f5a',
        transition: 'background-color 0.3s ease',
        '&:after': {
          transform: 'translateX(0.25em)',
        },
      },
      '&:focus': {
        outline: 'none',
        boxShadow: '0 0 0 3px rgba(39, 86, 129, 0.3)',
      },
      '& + a': {
        marginLeft: ['none', 'none', 'small'],
      },
    },
    orange: {
      variant: 'buttons.primary',
      bg: mandoPrimaryPalette.primaries.orange,
      color: '#000',
      '&:hover': {
        bg: '#E04800',
        transition: 'box-shadow 0s ease',
        boxShadow: "0 0 0 2px #E04800",
        '&:after': {
          transform: 'translateX(0.25em)',
        },
      },
    },
    lightGreen: {
      variant: 'buttons.primary',
      bg: '#E0F2E9',
      color: '#000',
      '&:hover': {
        bg: '#C8E6C9',
        transition: 'background-color 0.3s ease',
        '&:after': {
          transform: 'translateX(0.25em)',
        },
      },
    },
    gold: {
      variant: 'buttons.primary',
      background: 'linear-gradient(90deg, #FFA500 0%, #FFD700 100%)',
      color: '#000',
      '&:hover': {
        background: 'linear-gradient(90deg, #FF8C00 0%, #FFD700 100%)',
        transition: 'background 0.3s ease',
        '&:after': {
          transform: 'translateX(0.25em)',
        },
      },
    },
    black: {
      variant: 'buttons.primary',
      bg: '#000',
      color: '#fff',
      display: 'inline',
      padding: ['0.75em 2em', '0.75em 2.2em'],
      
      '&:hover': {
        bg: '#1c1b1b',
        transition: 'background-color .15s, color .15s',
        '&:after': {
          transform: 'translateX(0.25em)',
        },
      },
    },
    green: {
      variant: 'buttons.black',
      bg: '#095540',
      color: '#fff',
      '&:hover': {
        bg: '#042f23',
        transition: 'background-color .15s, color .15s',
        '&:after': {
          transform: 'translateX(0.25em)',
        },
      },
    },
    white: {
      variant: 'buttons.black',
      bg: '#fff',
      color: '#000',
      border: '1px solid #000',
      '&:hover': {
        // border: '2px solid #000',
        // transition: 'border .15s, color .15s',
        '&:after': {
          transform: 'translateX(0.25em)',
        },
      },
    },
    link: {
      variant: 'buttons.black',
      paddingLeft: 0,
      paddingRight: 0,
      bg: 'transparent',
      color: '#fff',
      textDecoration: 'underline',
      '&:hover': {
        bg: 'transparent',
        '&:after': {
          transform: 'translateX(0.25em)',
        },
      },
    },
    linkDark: {
      variant: 'buttons.link',
      color: 'heading',      
    },
    yellow: {
      variant: 'buttons.black',
      bg: '#FFE800',
      color: '#000',
      '&:hover': {
        bg: '#E2CE06',
        '&:after': {
          transform: 'translateX(0.25em)',
        },
      },
    },
    red: {
      variant: 'buttons.black',
      bg: '#FE3B1F',
      color: '#fff',
      '&:hover': {
        bg: '#E03219',
        '&:after': {
          transform: 'translateX(0.25em)',
        },
      },    
    },
    
  },
  // markdown styles
  styles: {
    root: {
      header: {
        fontSize: '11px',
      },
      variant: 'text.body',
      h1: {
        variant: 'text.heading',
        fontWeight: '700',
        fontSize: ['40px', '56px'],
        fontFamily: mandoPrimaryPalette.fonts.robotoSlab, 
        lineHeight: '1.1',
        letterSpacing: '0',
        textTransform: 'none',
        margin: '0 0 1rem 0',
      },
      h2: {
        variant: 'text.heading',
        fontSize: ['32px', '44px'],
        fontFamily: mandoPrimaryPalette.fonts.robotoSlab, 
        fontWeight: '700',
        lineHeight: '1.2',
        letterSpacing: '0',
        margin: '0 0 0.75rem 0',
      },
      h3: {
        variant: 'text.heading',
        fontSize: ['28px', '36px'],
        fontFamily: mandoPrimaryPalette.fonts.robotoSlab,
        fontWeight: '700',
        lineHeight: '1.3',
        letterSpacing: '0',
        margin: '0 0 0.5rem 0',
      },
      h4: {
        variant: 'text.heading',
        fontSize: ['22px', '28px'],
        fontFamily: mandoPrimaryPalette.fonts.robotoSlab,
        lineHeight: '1.4',
        letterSpacing: '0',
        fontWeight: '600',
        margin: '0 0 0.5rem 0',
      },
      h5: {
        variant: 'text.heading',
        fontSize: ['18px', '22px'],
        fontFamily: mandoPrimaryPalette.fonts.robotoSlab,
        lineHeight: '1.5',
        fontWeight: '600',
        letterSpacing: '0',
        margin: '0 0 0.5rem 0',
      },
      h6: {
        variant: 'text.heading',
        fontSize: ['16px', '18px'],
        fontFamily: mandoPrimaryPalette.fonts.roboto,
        fontWeight: '600',
        lineHeight: '1.5',
        letterSpacing: '0',
        margin: '0 0 0.5rem 0',
        textTransform: 'none'
      },
      // Utility classes to apply heading styles to any element
      // Usage: <h2 class="header-h5"> will be styled as h5
      '.header-h1': {
        variant: 'text.heading',
        fontWeight: '700',
        fontSize: ['40px', '56px'],
        fontFamily: mandoPrimaryPalette.fonts.robotoSlab, 
        lineHeight: '1.1',
        letterSpacing: '0',
        textTransform: 'none',
        margin: '0 0 1rem 0',
      },
      '.header-h2': {
        variant: 'text.heading',
        fontSize: ['32px', '44px'],
        fontFamily: mandoPrimaryPalette.fonts.robotoSlab, 
        fontWeight: '700',
        lineHeight: '1.2',
        letterSpacing: '0',
        margin: '0 0 0.75rem 0',
      },
      '.header-h3': {
        variant: 'text.heading',
        fontSize: ['28px', '36px'],
        fontFamily: mandoPrimaryPalette.fonts.robotoSlab,
        fontWeight: '700',
        lineHeight: '1.3',
        letterSpacing: '0',
        margin: '0 0 0.5rem 0',
      },
      '.header-h4': {
        variant: 'text.heading',
        fontSize: ['22px', '28px'],
        fontFamily: mandoPrimaryPalette.fonts.robotoSlab,
        lineHeight: '1.4',
        letterSpacing: '0',
        fontWeight: '600',
        margin: '0 0 0.5rem 0',
      },
      '.header-h5': {
        variant: 'text.heading',
        fontSize: ['18px', '22px'],
        fontFamily: mandoPrimaryPalette.fonts.robotoSlab,
        lineHeight: '1.5',
        fontWeight: '600',
        letterSpacing: '0',
        margin: '0 0 0.5rem 0',
      },
      '.header-h6': {
        variant: 'text.heading',
        fontSize: ['16px', '18px'],
        fontFamily: mandoPrimaryPalette.fonts.robotoSlab,
        fontWeight: '600',
        lineHeight: '1.5',
        letterSpacing: '0',
        margin: '0 0 0.5rem 0',
        textTransform: 'none'
      },
      p: {
        lineHeight: ['146%', '160%'],
        fontSize: '16px',
        fontFamily: mandoPrimaryPalette.fonts.roboto,
        letterSpacing: '-0.15px',
        margin: 0,
      },
      a: {
        color: 'link',
      },
      table: {
        borderCollapse: 'collapse',
        borderSpacing: 0,
      },
      tr: {
        fontSize: '1.1em',
      },
      th: {
        color: 'heading',
        padding: '0.4em',
        borderBottom: '2px solid rgba(0,0,0,0.2)',
        textTransform: 'uppercase',
        verticalAlign: 'middle',
      },
      td: {
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        padding: '0.4em',
        lineHeight: '1.8em',
        verticalAlign: 'middle',
        '& p': {
          fontSize: '80%',
          margin: '0.4em 0',
          lineHeight: '1.3',
        },
      },
    },
    textStyles: ['default', 'quote'],
    textColors: ['default', 'black', 'white', 'blue', 'navy', 'orange'],
    default: {
      h1: { 
        color: 'heading', 
      },
      h2: { 
        color: 'heading', 
      },
      h3: { 
        color: 'heading',
      },
      h4: { 
        color: 'heading',
      },
      h5: { 
        color: 'heading',
      },
      h6: { 
        color: 'heading'
      },
      p: {
        color: 'body'
      }
    },
    quote: {
      borderLeft: 'solid 4px #FE5000',
      padding: '10px 20px',
      color: '#000',
      fontFamily: mandoPrimaryPalette.fonts.blenderBold,
      lineHeight: '1.5',
      fontStyle: 'bold',
    }
  },
};

export default mandoStyles;